import { render, staticRenderFns } from "./SdCheckbox.vue?vue&type=template&id=fdb52276&scoped=true"
import script from "./SdCheckbox.vue?vue&type=script&lang=js"
export * from "./SdCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb52276",
  null
  
)

export default component.exports